
export function showElementByQuery(qs) {
  const elem = document.querySelector(qs)
  if (!elem) return false
  elem.scrollIntoView({ behavior: 'smooth', alignToTop: true })
  return true
}

export function jumpToTop() {
  return showElementByQuery('.top')
}